import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── Garanția blândă (din analiza concurenței: arma PsihoSensus/Giurgi, fără manipulare) ── */
export function HomeGuarantee() {
  const c = useSectionContent("home_guarantee");
  return (
    <section className="py-14" style={{ background: "var(--ct-surface)" }}>
      <div className="max-w-2xl mx-auto px-5 text-center">
        <ShieldCheck size={30} className="mx-auto mb-4" style={{ color: "var(--ct-gold)" }} />
        <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl mb-4">{c.title || "Garanția blândă"}</h2>
        <p data-el="body" data-field="body" className="text-base leading-relaxed max-w-xl mx-auto" style={{ color: "var(--ct-text-muted)" }}>
          {c.body || "La orice curs ai 14 zile să simți dacă ți se potrivește. Dacă nu, primești banii înapoi — fără întrebări, fără forme de completat, fără supărare. Vindecarea nu se face sub presiune."}
        </p>
      </div>
    </section>
  );
}
